import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { ROOT_URL } from "../../../config/url";
import {
  useAction,
  useList,
  useUnroll,
  useNotification,
  getErrorMessageByKey,
  useProfile,
} from "../../../components/ui";
import {ROLE_DIRECTOR, ROLE_EMPLOYEE} from "../../../config/constants";

export const useEmployees = () => {
  const { profile } = useProfile();
  const [selectRoleType, setSelectRoleType] = useState("null");

  const getUrlParams = () => {
    let params = null;
    if (!!selectRoleType && selectRoleType !== "null") {
      params = {
        ...params,
        "roles": selectRoleType,
      };
    } else {
      params = {
        ...params,
        "roles": [ROLE_DIRECTOR, ROLE_EMPLOYEE],
      };
    }
    return params;
  };

  const {
    list: [list, count, setList],
    update: [isUpdateList, setIsUpdateList, changeUpdate],
    page: [pageNumber, setPageNumber, pageLimit, setPageLimit],
    search: [searchQuery, setSearchQuery],
    setApiUrlParams,
  } = useList({
    apiUrl: "/api/employees",
    rootUrl: ROOT_URL,
    isPagination: true,
    paginationLimit: 100,
    isSearch: true,
    urlParams: getUrlParams(),
  });

  useEffect(() => {
    setApiUrlParams({ ...getUrlParams() });
  }, [selectRoleType]);

  const { unrolls, isUnroll, changeUnroll, changeAllUnroll } = useUnroll();

  const [isModalAddAccount, setIsModalAddAccount] = useState(false);
  const [modalEditAccount, setModalEditAccount] = useState(null);

  const inputSearchText = useRef(null);
  useEffect(() => {
    setPageNumber(1);
  }, [searchQuery]);

  const { setAction } = useAction(["employees", "isUpdate"], () => changeUpdate());

  useEffect(() => {
    if (!!list) {
      const listUuid = list.map((i) => i.account.uuid);
      setAction([...listUuid, "employees", "isUpdate"]);
    } else {
      setAction(["employees", "isUpdate"]);
    }
  }, [list]);

  const { notification } = useNotification();

  function onChangeSearchText() {
    setSearchQuery(inputSearchText.current.value);
  }

  const changePage = (data) => {
    if (pageNumber !== data.currentPage) {
      setPageNumber(data.currentPage);
    }
  };

  const isActivatedAccount = (uuid) => {
    axios
      .get("/api/employee/" + uuid + "/edit/activate", {
        withCredentials: false,
        baseURL: ROOT_URL,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("tokenSession"),
        },
      })
      .then(() => {
        setIsUpdateList(!isUpdateList);
      })
      .catch((error) => {
        notification(getErrorMessageByKey(error.response.data.error), "red");
      });
  };

  const changeSelectRoleType = (tag) => {
    setSelectRoleType(tag);
  };

  return {
    profile,

    list,
    setList,
    count,

    pageNumber,
    pageLimit,
    setPageLimit,
    changePage,

    unrolls,
    isUnroll,
    changeUnroll,
    changeAllUnroll,

    inputSearchText,
    onChangeSearchText,
    searchQuery,

    setIsUpdateList,
    isUpdateList,

    isActivatedAccount,

    modalEditAccount,
    setModalEditAccount,
    isModalAddAccount,
    setIsModalAddAccount,

    selectRoleType,
    changeSelectRoleType,
  };
};
